'use client'

import * as React from 'react'
import { motion } from 'motion/react'
import { LeftCaretIcon } from 'design-configuration/components/icons'

export enum PaginationDirection {
  Left = 'left',
  Right = 'right'
}

type PaginationButtonProps = {
  direction: PaginationDirection
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  className?: string
  children?: React.ReactNode
  iconClassName?: string
}

export const PaginationButton = ({
  direction,
  onClick,
  className,
  iconClassName,
  children
}: PaginationButtonProps): React.ReactElement => {
  return (
    <motion.button
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.8 }}
      whileHover={{ opacity: 1, scale: 1.1 }}
      className={`p-xs fill-on-primary flex items-center justify-center rounded-full ${className}`}
      transition={{ type: 'tween' }}
      onClick={onClick}
    >
      <LeftCaretIcon
        className={`w-sm h-sm fill-inherit ${direction === PaginationDirection.Left ? `` : `rotate-180`} ${iconClassName}`}
      />
      {children}
    </motion.button>
  )
}
